module.exports = __webpack_public_path__ + "img/img76.339aa2c3.svg";